
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PaymentRequestModel } from '@/models/payment-request';
import { BillOfLadingModel } from '@/models/bill-of-lading';

@Component
export default class ListOrder extends Vue {
    private eventEmit = {
        eventChangeData: 'eventChangeData'
    };

    @Prop({default: []})
    private orders!: BillOfLadingModel[];
    @Prop({default: null})
    private paymentRequest!: PaymentRequestModel;
    private isCheckAll = false;
    
    get totalOrder() {
        return this.orders.length;
    }
}
